<template>
    <StyleCarousel>
        <div class="banner-carousel owl-carousel owl-theme" id="banner-carousel">
            <div class="item" v-for="(banner, index) in data" :key="index">
                <a :href='banner.link ? banner.link : "#" ' target="_blank" rel="noopener noreferrer" >
                    <img
                        :src="banner.src"
                        :alt="`${banner.alt} informativo`"
                        :class="banner.class"
                        :loading="index === 0 ? 'eager' : 'lazy'"
                        :fetchpriority="index === 0 ? 'high' : 'auto'"
                        decoding="async"
                    />
                </a>
            </div>
        </div>
    </StyleCarousel>
</template>

<script>
import { StyleCarousel } from "./style";
export default {
  name: "Carousel",
  components: {
    StyleCarousel
  },
  props: {
    slides: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      data: []
    };
  },
  created() {
    this.imgs();
  },
  mounted() {
    this.initializeCarousel();
    this.setAriaLabels();
    
  },
  methods: {
    initializeCarousel() {
      $(document).ready(function(){
          $(".banner-carousel").owlCarousel({
              items: 1,
              loop: true,
              autoplay:  true,
              autoplayTimeout: 5000,
              nav: true,
              navText: ["<div class='custom-nav prev'><i class='fas fa-angle-left' style='font-size: 16px'></i></div>", "<div class='custom-nav next'><i class='fas fa-angle-right' style='font-size: 16px'></i></div>"],
              dots: true

          });
      });
    },
    setAriaLabels() {
      this.$nextTick(() => {
        let buttonPrev = document.querySelectorAll("button.owl-prev");
        let buttonNext = document.querySelectorAll("button.owl-next");
        let buttonDots = document.querySelectorAll("button.owl-dot");

        for (const button of buttonPrev) {
          button.setAttribute("aria-label", "Banner anterior");
          button.setAttribute("name", "Banner anterior");          
          button.removeAttribute("role"); // Remove role="presentation"
        }
        for (const button of buttonNext) {
          button.setAttribute("aria-label", "Próximo banner");
          button.setAttribute("name", "Próximo banner");

          button.removeAttribute("role"); // Remove role="presentation"
        }
        
        // Adicionar labels para os dots de navegação
        buttonDots.forEach((button, index) => {
          button.setAttribute("aria-label", `Ir para banner ${index + 1}`);
          button.setAttribute("title", `Banner ${index + 1}`);
        })
      });
    },
    imgs() {
        if (!this.slides.length) {
        return;
        }
        const mobileBanners = this.slides.filter(slide => slide.banner_mobile);

        if (window.innerWidth <= 700) {
            if (mobileBanners.length === 1) {
                const slide = mobileBanners[0];
                this.data.push({
                    src: slide.banner_mobile,
                    alt: 'Banner',
                    link: slide.link,
                    class: 'slide_mobile'
                });
            }
            else if (mobileBanners.length === 0) {
                this.slides.forEach(slide => {
                    this.data.push({
                        src: slide.banner,
                        alt: 'Banner',
                        link: slide.link,
                        class: 'slide-banner'
                    });
                });
            }
            else {
                mobileBanners.forEach(slide => {
                    this.data.push({
                        src: slide.banner_mobile,
                        alt: 'Banner',
                        link: slide.link,
                        class: 'slide_mobile'
                    });
                });
            }
        } else {
            this.slides.forEach(slide => {
                this.data.push({
                    src: slide.banner,
                    alt: 'Banner',
                    link: slide.link,
                    class: 'slide-banner'
                });
            });
        }
    }
  }
};
</script>

<style>
</style>
